<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asd</span></td>
                            <td class="text-center text-white font-weight-bold b-left" colspan="3">31 December 2020</td>
                            <td class="text-center text-white font-weight-bold b-left" colspan="3">31 December 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td class="text-white font-weight-bold b-right">Aging brackets<br/>of postpaid trade receivables</td>
                            <td class="text-right text-white font-weight-bold">Estimated<br/>total gross<br/>carrying<br/>amount at<br/>default</td>
                            <td class="text-right text-white font-weight-bold b-left">Expected<br/>credit loss <br/>rate</td>
                            <td class="text-right text-white font-weight-bold b-left">Lifetime ECL</td>
                            <td class="text-right text-white font-weight-bold b-left">Estimated<br/>total gross<br/>carrying<br/>amount at<br/>default</td>
                            <td class="text-right text-white font-weight-bold b-left">Expected<br/>credit loss <br/>rate</td>
                            <td class="text-right text-white font-weight-bold b-left">Lifetime ECL</td>
                        </tr>
                        <tr class="light-gray">
                            <td class="text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-center text-white font-weight-bold b-left">KD ’000</td>
                            <td class="text-center text-white font-weight-bold b-left">%</td>
                            <td class="text-center text-white font-weight-bold b-left"> KD ’000</td>
                            <td class="text-center text-white font-weight-bold b-left">KD ’000</td>
                            <td class="text-center text-white font-weight-bold b-left">%</td>
                            <td class="text-center text-white font-weight-bold b-left">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Not due /< 30 days</td>
                            <td class="text-right">180,681</td>
                            <td class="text-right">3%</td>
                            <td class="text-right">5,024</td>
                            <td class="text-right">186,560</td>
                            <td class="text-right">2%</td>
                            <td class="text-right">4,240</td>
                        </tr>
                        <tr>
                            <td>31 – 60 days</td>
                            <td class="text-right">10,547</td>
                            <td class="text-right">4%</td>
                            <td class="text-right">460</td>
                            <td class="text-right">27,585</td>
                            <td class="text-right">5%</td>
                            <td class="text-right">1,219</td>
                        </tr>
                        <tr>
                            <td>61 – 90 days</td>
                            <td class="text-right">8,493</td>
                            <td class="text-right">16%</td>
                            <td class="text-right">1,318</td>
                            <td class="text-right">8,674</td>
                            <td class="text-right">18%</td>
                            <td class="text-right">1,999</td>
                        </tr>
                        <tr>
                            <td>91 – 180 days</td>
                            <td class="text-right">16,069</td>
                            <td class="text-right">27%</td>
                            <td class="text-right">4,283</td>
                            <td class="text-right">21,343</td>
                            <td class="text-right">37%</td>
                            <td class="text-right">7,833</td>
                        </tr>
                        <tr>
                            <td> > 181 days</td>
                            <td class="text-right">230,054</td>
                            <td class="text-right">78%</td>
                            <td class="text-right">180,115</td>
                            <td class="text-right">192,734</td>
                            <td class="text-right">74%</td>
                            <td class="text-right">143,371</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold">445,844</td>
                            <td class="text-right text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold"> 191,200</td>
                            <td class="text-right text-white font-weight-bold">436,896</td>
                            <td class="text-right text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold">158,662</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asd</span></td>
                            <td class="text-center text-white font-weight-bold b-left" colspan="3">31 ديسمبر 2020</td>
                            <td class="text-center text-white font-weight-bold b-left" colspan="3">31 ديسمبر 2019</td>
                        </tr>
                        <tr class="med-gray">
                            <td class="text-white font-weight-bold b-right">فئات التحليل العمري للذمم التجارية<br/>المدينة لعملاء الدفع الآجل</td>
                            <td class="text-right text-white font-weight-bold">مجمل القيمة<br/>الدفترية<br/>المقدرة عند<br/>التعثر</td>
                            <td class="text-right text-white font-weight-bold b-left">معدل الخسارة <br/>الائتمانية<br/>المتوقعة</td>
                            <td class="text-right text-white font-weight-bold b-left">الخسارة<br/>الائتمانية<br/>المتوقعة خلال<br/>عمر الأداة</td>
                            <td class="text-right text-white font-weight-bold b-left">مجمل القيمة<br/>الدفترية<br/>المقدرة عند<br/>التعثر</td>
                            <td class="text-right text-white font-weight-bold b-left">معدل الخسارة<br/>الائتمانية<br/>المتوقعة</td>
                            <td class="text-right text-white font-weight-bold b-left">الخسارة<br/>الائتمانية<br/>المتوقعة خلال<br/>عمر الأداة</td>
                        </tr>
                        <tr class="light-gray">
                            <td class="text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-center text-white font-weight-bold b-left">ألف دينار<br/>كويتي</td>
                            <td class="text-center text-white font-weight-bold b-left">%</td>
                            <td class="text-center text-white font-weight-bold b-left">ألف دينار<br/>كويتي</td>
                            <td class="text-center text-white font-weight-bold b-left">ألف دينار<br/>كويتي</td>
                            <td class="text-center text-white font-weight-bold b-left">%</td>
                            <td class="text-center text-white font-weight-bold b-left">ألف دينار<br/>كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>غير مستحقة/ أقل من 30 يوماً</td>
                            <td class="text-right">180,681</td>
                            <td class="text-right">%3</td>
                            <td class="text-right">5,024</td>
                            <td class="text-right">186,560</td>
                            <td class="text-right">%2</td>
                            <td class="text-right">4,240</td>
                        </tr>
                        <tr>
                            <td>31 – 60 يوماً</td>
                            <td class="text-right">10,547</td>
                            <td class="text-right">%4</td>
                            <td class="text-right">460</td>
                            <td class="text-right">27,585</td>
                            <td class="text-right">%5</td>
                            <td class="text-right">1,219</td>
                        </tr>
                        <tr>
                            <td>61 – 90 يوماً</td>
                            <td class="text-right">8,493</td>
                            <td class="text-right">%16</td>
                            <td class="text-right">1,318</td>
                            <td class="text-right">8,674</td>
                            <td class="text-right">%18</td>
                            <td class="text-right">1,999</td>
                        </tr>
                        <tr>
                            <td>91 – 180 يوماً</td>
                            <td class="text-right">16,069</td>
                            <td class="text-right">%27</td>
                            <td class="text-right">4,283</td>
                            <td class="text-right">21,343</td>
                            <td class="text-right">%37</td>
                            <td class="text-right">7,833</td>
                        </tr>
                        <tr>
                            <td>أكثر من 181 يوماً</td>
                            <td class="text-right">230,054</td>
                            <td class="text-right">%78</td>
                            <td class="text-right">180,115</td>
                            <td class="text-right">192,734</td>
                            <td class="text-right">%74</td>
                            <td class="text-right">143,371</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold">445,844</td>
                            <td class="text-right text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold"> 191,200</td>
                            <td class="text-right text-white font-weight-bold">436,896</td>
                            <td class="text-right text-white font-weight-bold"><span class="invisible">asd</span></td>
                            <td class="text-right text-white font-weight-bold">158,662</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>